import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Listbox, Transition } from "@headlessui/react";
import { yupResolver } from "@hookform/resolvers/yup";
import { get, replace } from "lodash";
import queryString from "query-string";
import React, {
  Fragment,
  useEffect,
  useState,
  useRef,
  useCallback,
} from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useParams, useHistory } from "react-router-dom";
import config from "src/config";
import { i18n } from "src/i18n";
import scrollLock from "src/lib/scrollLock";
import actions from "src/modules/auth/authActions";
import { AuthCurrencies } from "src/modules/auth/authCurrencies";
import selectors from "src/modules/auth/authSelectors";
import { AuthTimezones } from "src/modules/auth/authTimezones";
import entitlementLabel from "src/modules/entitlement/entitlementLabel";
import EntitlementService from "src/modules/entitlement/entitlementService";
import PlanService from "src/modules/plan/planService";
import classNames from "src/modules/shared/classNames";
import Errors from "src/modules/shared/error/errors";
import yupFormSchemas from "src/modules/shared/yup/yupFormSchemas";
import { getHistory } from "src/modules/store";
import CheckboxFormItem from "src/view/shared/form/items/CheckboxFormItem";
import InputFormItem from "src/view/shared/form/items/InputFormItem";
import ListBoxFormItem from "src/view/shared/form/items/ListBoxFormItem";
import PasswordFormItem from "src/view/shared/form/items/PasswordFormItem";
import PhoneNumberFormItem from "src/view/shared/form/items/PhoneNumberFormItem";
import SelectFormItem from "src/view/shared/form/items/SelectFormItem";
import SwitchFormItem from "src/view/shared/form/items/SwitchFormItem";
import Spinner from "src/view/shared/Spinner";
import IdMeModal from "src/modules/shared/modal/Idme";
import service from "src/modules/auth/authService";
import * as toastr from "toastr";
import "toastr/build/toastr.css";
import * as yup from "yup";
import axios from "axios";
import { visibility } from "html2canvas/dist/types/css/property-descriptors/visibility";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "./CheckoutFormV2";
import DummyCheckoutFormV2 from "./DummyCheckoutFormV2";
import CheckoutFormV2 from "./CheckoutFormV2";
import { AuthToken } from "src/modules/auth/authToken";
import PaymentSection from "./PaymentSection";
import PermissionChecker from "src/modules/auth/permissionChecker";
import styles from "./SignupPage.module.scss";

// Ở đầu tập tin của bạn trước component
window.stripeCheckoutForm = null;

let mounted = 0;
const schema = yup.object().shape({
  firstName: yupFormSchemas.string(i18n("user.fields.firstName"), {
    max: 80,
    required: true,
    messages: {
      required: "First name is required",
      max: "First name cannot exceed 80 characters",
    },
  }),
  lastName: yupFormSchemas.string(i18n("user.fields.lastName"), {
    max: 175,
    required: true,
    messages: {
      required: "Last name is required",
      max: "Last name cannot exceed 175 characters",
    },
  }),
  email: yupFormSchemas.email(i18n("user.fields.email"), {
    max: 255,
    required: true,
    messages: {
      required: "Email is required",
      max: "Email cannot exceed 255 characters",
      email: "Please enter a valid email address",
    },
  }),
  password: yupFormSchemas.string(i18n("user.fields.password"), {
    min: 8,
    required: true,
    messages: {
      required: "Password is required",
      min: "Password must be at least 8 characters",
    },
  }),
  confirmPassword: yupFormSchemas
    .string(i18n("user.fields.passwordConfirmation"), {
      required: true,
      messages: {
        required: "Password confirmation is required",
      },
    })
    .oneOf([yup.ref("password"), null], i18n("auth.passwordChange.mustMatch")),
  phoneNumber: yupFormSchemas.string(i18n("user.fields.phoneNumber"), {
    required: false,
    matches: /^[0-9]/,
  }),
  phoneOptIn: yupFormSchemas.boolean(i18n("user.fields.phoneOptIn")),
  timezone: yupFormSchemas.string(i18n("user.fields.timezone"), {
    required: false,
  }),
});

function multiplyByTwelve(input) {
  const number = parseFloat(input); // Convert to a number
  if (isNaN(number)) {
    throw new Error(
      "Invalid input: Please provide a number or a numeric string."
    );
  }
  return number * 12; // Return the product
}

function SignupPage() {
  const dispatch = useDispatch();
  const { provider } = useParams();
  const [isPartner, setIsPartner] = useState(
    localStorage.getItem("isPartner")
      ? JSON.parse(localStorage.getItem("isPartner"))
      : undefined
  );
  const [partnerRoute, setPartnerRoute] = useState(
    localStorage.getItem("provider")
  );
  const location = useLocation();
  const history = useHistory();
  const [state, setState] = useState("idle");
  const [step1Complete, setStep1Complete] = useState(false); // Theo dõi trạng thái bước 1
  const [registeredUserData, setRegisteredUserData] = useState(null);

  const [entitlement, setEntitlement] = useState<any>(null);
  const [entitlements, setEntitlements] = useState<any>([]);
  const [credentials, setCredentials] = useState<any>([]);
  const [entitlementsLoading, setEntitlementsLoading] = useState(true);
  const saveLoading = useSelector(selectors.selectLoading);
  const [couponCode, setCouponCode] = useState("");
  const [countryCode, setCountryCode] = useState(null);
  const [token, setToken] = useState(null);

  // Subscription related states
  const [activeTab, setActiveTab] = useState("Monthly");
  const [planList, setPlanList] = useState<any[]>([]);
  const [selectedPlan, setSelectedPlan] = useState<any>(null);
  const [total, setTotal] = useState<any>(0);

  const externalErrorMessage = useSelector(selectors.selectErrorMessage);
  const [idmeModalOpen, setidmeModalOpen] = useState(false);

  // Get current user to check subscription status
  const currentUser = useSelector(selectors.selectCurrentUser);
  const currentTenant = useSelector(selectors.selectCurrentTenant);

  const emailFromInvitation = queryString.parse(location.search).email;
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const code = params.get("code");

  const soaakUrl = `/images/logo-soaak-v2.svg`;
  const userUrl = `/images/user.svg`;
  const circleDownIcon = `/images/circle-down.svg`;
  const circleDown2Icon = `/images/circle-down2.svg`;

  // Thêm state để theo dõi và hiển thị thông báo
  const [stateMessage, setStateMessage] = useState("");

  // Function để clear toàn bộ browser data khi API lỗi
  const clearAllBrowserData = (shouldReload = true) => {
    // Clear ALL localStorage
    localStorage.clear();
    
    // Clear ALL sessionStorage 
    sessionStorage.clear();
    
    // Clear ALL cookies
    document.cookie.split(";").forEach(cookie => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
      if (name) {
        // Clear for current domain and path
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname}`;
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
        // Clear for parent domain (if subdomain)
        const parentDomain = window.location.hostname.split('.').slice(-2).join('.');
        if (parentDomain !== window.location.hostname) {
          document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${parentDomain}`;
        }
      }
    });
    
    // Clear ALL caches
    if ('caches' in window) {
      caches.keys().then(cacheNames => {
        cacheNames.forEach(cacheName => {
          caches.delete(cacheName);
        });
      }).catch(err => console.warn('Cache clearing failed:', err));
    }
    
    // Clear service workers
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then(registration => {
        return registration.unregister();
      }).catch(err => console.warn('Service worker unregister failed:', err));
    }
    
    console.log("🧹 CLEARED: All browser data cleared (localStorage, sessionStorage, cookies, caches)");
    
    // Reload trang sau khi clear xong
    if (shouldReload) {
      setTimeout(() => {
        window.location.reload();
      }, 100); // Delay nhỏ để đảm bảo clear hoàn tất
    }
  };

  useEffect(() => {
    scrollLock.disable();
    dispatch(actions.doClearErrorMessage());
  }, [dispatch]);

  useEffect(() => {
    const head = document.head;
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src =
      "https://t.soaak.com/v1/lst/universal-script?ph=066b8ecb9011327eaae35e1d779e488a6d43664d0cce14e3b58fa66629719b93&tag=!clicked";
    head.appendChild(script);

    return () => {
      head.removeChild(script);
    };
  }, []);

  // Check if user is logged in but not subscribed
  useEffect(() => {
    if (currentUser && currentTenant) {
      const permissionChecker = new PermissionChecker(
        currentTenant,
        currentUser
      );

      // If user is logged in but not subscribed, enable step 2
      if (!permissionChecker.isSubscribed) {
        // Set step 1 as complete since user is already logged in
        setStep1Complete(true);

        // Fetch plans for step 2
        fetchPlans(activeTab);
      }
    }
  }, [currentUser, currentTenant]);

  // Khi component khởi tạo, cần kiểm tra query parameters để xem có step=2 không
  useEffect(() => {
    // Kiểm tra query parameter "step"
    const params = new URLSearchParams(location.search);
    const step = params.get("step");

    if (step === "2") {
      // Nếu step=2, đặt trạng thái bước 1 là đã hoàn thành
      setStep1Complete(true);

      // Nếu người dùng đã đăng nhập, lấy thông tin người dùng để điền vào registeredUserData
      if (currentUser) {
        setRegisteredUserData({
          firstName: currentUser.firstName,
          lastName: currentUser.lastName,
          email: currentUser.email,
          phoneNumber: currentUser.phoneNumber || "",
        });

        // Tải danh sách gói đăng ký
        fetchPlans(activeTab);
      }
    }
  }, [location.search, currentUser]);

  // Fetch plans when component mounts
  useEffect(() => {
    fetchPlans(activeTab);
  }, [activeTab]);

  const fetchPlans = async (renewalPeriod) => {
    try {
      setEntitlementsLoading(true);

      const response = await EntitlementService.list(renewalPeriod);
      setPlanList(response);
      if (response && response.length > 0) {
        setSelectedPlan(response[1]);
        setTotal(response[1].retailPrice);
      }
      setEntitlementsLoading(false);
    } catch (error) {
      setEntitlementsLoading(false);
      
      // Clear toàn bộ browser data khi EntitlementService.list lỗi
      console.warn("EntitlementService.list failed, clearing all browser data");
      clearAllBrowserData();
      
      Errors.handle(error);
    }
  };

  useEffect(() => {
    mounted++;
  }, []);

  // Lấy dữ liệu người dùng đã đăng ký từ localStorage (nếu có)
  const storedUserData = localStorage.getItem("registeredUserData")
    ? JSON.parse(localStorage.getItem("registeredUserData"))
    : null;


  // Lấy dữ liệu người dùng từ currentUser hoặc localStorage
  const getUserData = () => {
    // Ưu tiên sử dụng dữ liệu từ currentUser nếu có
    if (currentUser) {
      return {
        firstName: currentUser.firstName || "",
        lastName: currentUser.lastName || "",
        email: currentUser.email || "",
        phoneNumber: currentUser.phoneNumber || "",
        // Các trường khác không có trong currentUser, có thể lấy từ localStorage
        ...storedUserData,
      };
    }

    // Nếu không có currentUser, sử dụng dữ liệu từ localStorage
    return storedUserData;
  };

  const userData = getUserData();

  const [initialValues] = useState({
    firstName: userData?.firstName || "",
    lastName: userData?.lastName || "",
    phoneNumber: userData?.phoneNumber || "",
    email: userData?.email || emailFromInvitation || "",
    confirmEmail: userData?.email || emailFromInvitation || "",
    phoneOptIn: userData?.phoneOptIn !== undefined ? userData.phoneOptIn : true,
    password: userData?.password || "",
    timezone: userData?.timezone || AuthTimezones.defaultTimezone(),
    currency: userData?.currency || AuthTimezones.extractCurrencyFromTimezone(),
    renewalPeriod: userData?.renewalPeriod || "Monthly",
    termsOfService: userData?.termsOfService || false,
    privacyPolicy:
      userData?.privacyPolicy !== undefined ? userData.privacyPolicy : true,
    promoCode: userData?.promoCode || "",
  });

  const form = useForm({
    resolver: yupResolver(schema),
    mode: "onSubmit",
    defaultValues: initialValues,
  });

  const formState = form.formState;
  const isValid = formState.isValid;
  const isSubmitted = formState.isSubmitted;

  // Khôi phục trạng thái khi tải lại trang
  useEffect(() => {
    // Nếu người dùng đã đăng nhập, sử dụng dữ liệu từ currentUser
    if (currentUser) {
      // Đặt bước 1 là đã hoàn thành
      setStep1Complete(true);

      // Đặt dữ liệu người dùng
      setRegisteredUserData({
        firstName: currentUser.firstName,
        lastName: currentUser.lastName,
        email: currentUser.email,
        phoneNumber: currentUser.phoneNumber || "",
      });

      // Reset form với dữ liệu từ currentUser
      form.reset({
        firstName: currentUser.firstName,
        lastName: currentUser.lastName,
        email: currentUser.email,
        phoneNumber: currentUser.phoneNumber || "",
        // Giữ lại các giá trị khác từ form hiện tại
        ...form.getValues(),
      });

      // Tải danh sách gói đăng ký
      fetchPlans(activeTab);

      // Hiển thị thông báo
      setStateMessage("Welcome back! Continue to payment");
      setTimeout(() => setStateMessage(""), 5000);
    }
    // Nếu người dùng chưa đăng nhập nhưng có token
    else if (!currentUser && AuthToken.get()) {
      // Gọi API để lấy thông tin người dùng
      (async () => {
        try {
          setState("loading");

          // Lấy thông tin người dùng từ API
          const userData = await service.fetchMe();

          if (userData) {
            // Thiết lập bước 1 là đã hoàn thành
            setStep1Complete(true);

            // Đặt dữ liệu người dùng
            setRegisteredUserData({
              firstName: userData.firstName,
              lastName: userData.lastName,
              email: userData.email,
              phoneNumber: userData.phoneNumber || "",
            });

            // Reset form với dữ liệu từ API
            form.reset({
              firstName: userData.firstName,
              lastName: userData.lastName,
              email: userData.email,
              phoneNumber: userData.phoneNumber || "",
              // Giữ lại các giá trị khác
              ...form.getValues(),
            });

            // Hiển thị thông báo
            setStateMessage(
              "The registration has been restored, please continue to payment"
            );
            setTimeout(() => setStateMessage(""), 5000);

            // Tải danh sách gói đăng ký
            fetchPlans(activeTab);
          }

          setState("idle");
        } catch (error) {
          console.error("Error fetching user data:", error);
          setState("idle");

          // Nếu không thể lấy dữ liệu từ API, thử sử dụng localStorage
          tryRestoreFromLocalStorage();
        }
      })();
    }
    // Nếu không có token nhưng có dữ liệu trong localStorage
    else {
      tryRestoreFromLocalStorage();
    }
  }, [currentUser]);

  // Hàm để thử khôi phục dữ liệu từ localStorage
  const tryRestoreFromLocalStorage = () => {
    const registrationCompleted =
      localStorage.getItem("registrationCompleted") === "true";
    const storedUserData = localStorage.getItem("registeredUserData");

    if (registrationCompleted && storedUserData) {
      try {
        const userData = JSON.parse(storedUserData);
        setStep1Complete(true);
        setRegisteredUserData(userData);

        // Reset form với dữ liệu từ localStorage
        form.reset({
          ...userData,
          // Giữ lại các giá trị khác
          ...form.getValues(),
        });

        // Hiển thị thông báo
        setStateMessage("Registration data restored from local storage");
        setTimeout(() => setStateMessage(""), 5000);

        // Nếu có thông tin đăng nhập, thử đăng nhập lại
        if (userData.email && userData.password) {
          loginWithStoredCredentials(userData);
        } else {
          // Tải danh sách gói đăng ký
          fetchPlans(activeTab);
        }
      } catch (error) {
        console.error("Error parsing stored user data:", error);
      }
    }
  };

  // Hàm để đăng nhập với thông tin đã lưu
  const loginWithStoredCredentials = async (userData) => {
    try {
      setState("loading");
      const loginToken = await service.signinWithEmailAndPassword(
        userData.email,
        userData.password
      );

      // Set token
      AuthToken.set(loginToken, true);
      setState("idle");

      // Hiển thị thông báo đăng nhập thành công
      setStateMessage("Login successful");
      setTimeout(() => setStateMessage(""), 5000);

      // Lấy thông tin người dùng từ API sau khi đăng nhập thành công
      const updatedUserData = await service.fetchMe();
      if (updatedUserData) {
        setRegisteredUserData({
          firstName: updatedUserData.firstName,
          lastName: updatedUserData.lastName,
          email: updatedUserData.email,
          phoneNumber: updatedUserData.phoneNumber || "",
          // Giữ lại mật khẩu để có thể sử dụng sau này nếu cần
          password: userData.password,
        });

        // Reset form với dữ liệu mới nhất
        form.reset({
          firstName: updatedUserData.firstName,
          lastName: updatedUserData.lastName,
          email: updatedUserData.email,
          phoneNumber: updatedUserData.phoneNumber || "",
          // Giữ lại các giá trị khác
          ...form.getValues(),
        });
      }

      // Tải danh sách gói đăng ký
      fetchPlans(activeTab);
    } catch (error) {
      console.error("Error auto-login after page refresh:", error);
      setState("idle");

      // Hiển thị thông báo lỗi đăng nhập
      setStateMessage("Unable to auto-login, please check your information");
      setTimeout(() => setStateMessage(""), 5000);

      // Vẫn tải danh sách gói đăng ký
      fetchPlans(activeTab);
    }
  };

  // Lưu token cùng với dữ liệu người dùng
  const saveRegistrationState = (userData, token) => {
    localStorage.setItem("registrationCompleted", "true");
    localStorage.setItem("registeredUserData", JSON.stringify(userData));
    if (token) {
      localStorage.setItem("token", token);
    }
  };

  // Xóa hết dữ liệu đã lưu sau khi hoàn tất thanh toán
  const clearRegistrationState = () => {
    localStorage.removeItem("registrationCompleted");
    localStorage.removeItem("registeredUserData");
    localStorage.removeItem("token");
  };

  const onRegisterSubmit = async (data, event) => {
    if (event) event.preventDefault();

    try {
      setState("loading");

      // User registration data
      const userData = {
        ...data,
        countryCode: countryCode,
        termsOfService: true, // Mặc định đặt là true vì sẽ kiểm tra ở bước thanh toán
      };

      // Step 1: Register new user
      const tokenResponse = await service.registerWithEmailAndPassword(
        userData
      );
      setToken(tokenResponse);

      // Step 2: Login with the credentials
      const loginToken = await service.signinWithEmailAndPassword(
        userData.email,
        userData.password
      );

      // Set token
      AuthToken.set(loginToken, true);

      // Save registered user data for the payment section
      setRegisteredUserData(userData);

      // Lưu trạng thái đăng ký vào localStorage
      saveRegistrationState(userData, tokenResponse);

      // Mark step 1 as complete
      setStep1Complete(true);

      // Scroll to payment section
      const paymentSection = document.getElementById("payment-section");
      if (paymentSection) {
        paymentSection.scrollIntoView({ behavior: "smooth" });
      }

      setState("idle");
    } catch (error) {
      console.error("Error during registration:", error);
      Errors.handle(error);
      setState("idle");
    }
  };

  const onPaymentComplete = (success) => {
    setState("idle");
    if (success) {
      // Xóa trạng thái đăng ký khi thanh toán hoàn tất
      clearRegistrationState();

      // Handle different redirect paths based on partner status
      if (isPartner || provider) {
        localStorage.removeItem("isPartner");
        if (provider) {
          window.location.href = `/auth/survey/${provider}`;
        } else if (partnerRoute) {
          window.location.href = `/auth/survey/${partnerRoute}`;
        } else {
          window.location.href = "/auth/survey";
        }
      } else {
        window.location.href = "/auth/survey";
      }
    }
  };

  const fetchIdmeCredentials = async () => {
    try {
      const credentials = await service.idmeCredentials();
      setCredentials(credentials);
      localStorage.setItem("codeChallenge", credentials.codeChallenge);
      localStorage.setItem("codeVerifier", credentials.codeVerifier);
      localStorage.setItem(
        "code_challenge_method",
        credentials.code_challenge_method
      );
      localStorage.setItem("redirect_uri", credentials.redirect_uri);
    } catch (error) {
      console.error("service.idmeCredentials() failed:", error);
      
      // Clear toàn bộ browser data khi service.idmeCredentials lỗi
      console.warn("service.idmeCredentials failed, clearing all browser data");
      clearAllBrowserData(false); // Không reload vì sẽ redirect
      
      // Redirect về signin page
      window.location.href = "/auth/signin";
    }
  };

  const fetchToken = async () => {
    try {
      const credentials = await service.idmeCredentials();
      const data = {
        grant_type: "authorization_code",
        code: `${code}`,
        code_verifier: localStorage.getItem("codeVerifier"),
        redirect_uri: credentials.redirect_uri,
      };

      const response = await service.idmeToken(data);

      if (response === "Request failed with status code 400") {
        setidmeModalOpen(true);
        return;
      } else if (response) {
        const storeIdmeResponse = await service.storeIdmeResponse(response);
        if (storeIdmeResponse.status == 200) {
          dispatch(
            actions.doRegisterEmailAndPassword({
              token: token,
              pushOptIn: true,
            })
          );
          window.location.href = "/auth/subscription";
        }
      }
    } catch (error) {
      console.error("service.idmeCredentials() in fetchToken failed:", error);
      
      // Clear toàn bộ browser data khi service.idmeCredentials lỗi
      console.warn("service.idmeCredentials in fetchToken failed, clearing all browser data");
      clearAllBrowserData(false); // Không reload vì sẽ redirect
      
      // Redirect về signin page
      window.location.href = "/auth/signin";
    }
  };

  // Function to handle manual activation of step 2
  const activateStep2 = () => {
    // Scroll to payment section
    const paymentSection = document.getElementById("payment-section");
    if (paymentSection) {
      paymentSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    if (!code) {
      fetchIdmeCredentials();
    } else {
      fetchToken();
    }

    if (provider) {
      localStorage.setItem("isPartner", JSON.stringify(true));
      localStorage.setItem("provider", provider);
      setIsPartner(true);
      setPartnerRoute(provider);
    } else {
      localStorage.removeItem("isPartner");
      localStorage.removeItem("provider");
      setIsPartner(undefined);
      setPartnerRoute(undefined);
    }
  }, []);

  // Cập nhật trường readOnly cho các trường input khi đã hoàn thành bước 1
  useEffect(() => {
    if (step1Complete) {
      // Disable all form fields after step 1 is complete
      const formFields = document.querySelectorAll(
        ".registration-form input, .registration-form select"
      );
      formFields.forEach((field: any) => {
        field.disabled = true;
      });
    }
  }, [step1Complete]);

  const onLogout = () => {
    // Xóa token và dữ liệu đã lưu
    service.signout();
    clearRegistrationState();

    // Chuyển hướng về trang đăng nhập
    const redirectPath = isPartner
      ? `/auth/signin/${partnerRoute}`
      : "/auth/signin";
    window.location.href = redirectPath;
  };

  return (
    <>
      <div
        className={`${styles.container} flex-col bg-gray-50 bg-[url('/images/bg.png')] bg-cover bg-center bg-no-repeat font-['Plus_Jakarta_Sans']`}
      >
        {state === "loading" && (
          <div className="fixed top-0 left-0 z-40 flex items-center w-full h-full bg-gray-500 opacity-60">
            <Spinner />
          </div>
        )}

        {stateMessage && (
          <div className="fixed left-1/2 top-5 z-50 -translate-x-1/2 transform rounded-md bg-[#005363] px-4 py-2 text-white shadow-lg">
            {stateMessage}
          </div>
        )}

        <div className={styles.formContainer}>
          <div className="flex items-center justify-center w-full">
            {soaakUrl ? (
              <img
                src={soaakUrl}
                className={`${styles.logo} object-fit`}
                alt={i18n("app.title")}
              />
            ) : (
              <h1 className="text-3xl font-semibold text-center text-darkGreen">
                {i18n("app.title")}
              </h1>
            )}
          </div>

          {/* Registration Form (Step 1) */}
          <div
            className={`transition-all duration-300 ${
              step1Complete ? "opacity-70" : "opacity-100"
            }`}
          >
            <FormProvider {...form}>
              <form
                onSubmit={form.handleSubmit(onRegisterSubmit)}
                className="registration-form"
              >
                <div className="my-[10px]">
                  <h2 className={styles.sectionTitle}>1. Register</h2>
                  <p className={styles.sectionDescription}>
                    Enter your details below to create{" "}
                    <br className="hidden sm:block" /> your account and get
                    started.
                  </p>
                </div>

                <div className={styles.card}>
                  <div className={styles.cardHeader}>
                    <img src={userUrl} alt="logo" className="rounded-full" />
                    <p className="text-[11px] font-[300] leading-[16px] sm:text-[13px] opacity-60">
                      Required
                    </p>
                  </div>

                  <div className={styles.formGrid}>
                    <div>
                      <InputFormItem
                        name="firstName"
                        autoComplete="firstName"
                        required={isSubmitted && !isValid}
                        placeholder="First Name"
                        externalErrorMessage={externalErrorMessage}
                        disabled={step1Complete}
                        noMessageError={true}
                        className={styles.input}
                      />
                    </div>
                    <div>
                      <InputFormItem
                        name="lastName"
                        autoComplete="lastName"
                        required={isSubmitted && !isValid}
                        placeholder="Last Name"
                        disabled={step1Complete}
                        noMessageError={true}
                        className={styles.input}
                      />
                    </div>
                    <div>
                      <InputFormItem
                        name="email"
                        type="email"
                        autoComplete="email"
                        externalErrorMessage={externalErrorMessage}
                        required={isSubmitted && !isValid}
                        placeholder="Email Address"
                        disabled={step1Complete}
                        noMessageError={true}
                        className={styles.input}
                      />
                    </div>
                    <div>
                      <PasswordFormItem
                        name="password"
                        autoComplete="new-password"
                        required={true}
                        ignoredErrorTypes={[]}
                        placeholder="Password"
                        disabled={step1Complete}
                        noMessageError={true}
                        className={styles.input}
                      />
                    </div>
                    <div>
                      <PasswordFormItem
                        name="confirmPassword"
                        autoComplete="new-password"
                        required={true}
                        ignoredErrorTypes={[]}
                        placeholder="Confirm Password"
                        disabled={step1Complete}
                        noMessageError={true}
                        className={styles.input}
                      />
                    </div>
                  </div>

                  <div className={styles.loginLink}>
                    <div className="block h-full w-full pt-4 text-center text-[12px] font-[300] sm:text-[14px]">
                      {i18n("auth.alreadyHaveAnAccount")}
                      <Link
                        className=""
                        to={
                          isPartner
                            ? `/auth/signin/${partnerRoute}`
                            : "/auth/signin"
                        }
                      >
                        <span className="underline">{i18n("auth.login")}</span>
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="mt-6 text-center">
                  {!step1Complete ? (
                    <>
                      <button
                        disabled={saveLoading}
                        type="submit"
                        className={`${styles.button} bg-white text-[#035C67] shadow-[0px_3px_3px_0px_#0000004D]`}
                      >
                        Continue to Payment
                      </button>
                      {isSubmitted && !isValid && (
                        <div className="mt-3 text-[12px] text-[#E88697] sm:text-[14px]">
                          {Object.keys(formState.errors).map((fieldName) => {
                            const error = formState.errors[fieldName];
                            return (
                              <div key={fieldName} className="mb-1">
                                {error?.message && <>* {error.message}</>}
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </>
                  ) : (
                    <button
                      type="button"
                      onClick={onLogout}
                      className={`${styles.button} bg-white text-[#035C67]`}
                    >
                      Back to Login
                    </button>
                  )}
                </div>
              </form>
            </FormProvider>
          </div>

          {/* Payment Section (Step 2) */}
          <div
            id="payment-section"
            className={`transition-all duration-500 ${
              step1Complete ? "opacity-100" : "pointer-events-none opacity-50"
            }`}
          >
            <PaymentSection
              userData={registeredUserData}
              planList={planList}
              activeTab={activeTab}
              selectedPlan={selectedPlan}
              setSelectedPlan={setSelectedPlan}
              total={total}
              setTotal={setTotal}
              onPaymentComplete={onPaymentComplete}
              setActiveTab={setActiveTab}
              step1Complete={step1Complete}
            />
          </div>
        </div>
      </div>

      {idmeModalOpen && (
        <IdMeModal
          credentials={credentials}
          handleSkip={() => {
            window.location.href = "/auth/subscription";
            dispatch(
              actions.doRegisterEmailAndPassword({
                token: token,
                pushOptIn: true,
              })
            );
          }}
        />
      )}
    </>
  );
}

export default SignupPage;
